import MainApi from "./axiosInstance";
import Urls from "../utils/constants/urls";

class UserService {
    updatePartnerDetails(payload: any) {
        return MainApi.patch(Urls.updateUser, payload)
    }
}

export default new UserService()